import { ReporteDeudasVigentesTgrDto } from "../reportes-api.services";

function parsearMonto(valor: string): number {
    return Number(valor.replaceAll(',', ''));
}

function parsearFechaTgr(valor: string): string {
    const meses: Record<string, string> = {
        Ene: '01',
        Feb: '02',
        Mar: '03',
        Abr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Ago: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dic: '12'
    };

    const [dia, mes, anio] = valor.split('-');

    if (!dia || !mes || !anio || !meses[mes]) {
        return valor;
    }

    return `${anio}-${meses[mes]}-${dia.padStart(2, '0')}`;
}

export function parsearDeudasVigentesTgr(
    dto: ReporteDeudasVigentesTgrDto
) {
    return {
        rut: dto.rut,
        generadoEn: dto.generadoEn,

        deudas: (dto.deudas ?? []).map((deuda) => ({
            folio: deuda.folio,

            fechaVencimiento:
                parsearFechaTgr(deuda.fechaVencimiento),

            deudaNeta:
                parsearMonto(deuda.deudaNeta),

            reajuste:
                parsearMonto(deuda.reajuste),

            interes:
                parsearMonto(deuda.interes),

            multa:
                parsearMonto(deuda.multa),

            total:
                parsearMonto(deuda.total)
        }))
    };
}